<template>
  <div>
    <input type="file"
           ref="imageLoader"
           v-show="false"
           @change="convertImageToBase64"
           accept="image/*">
    <div class='info-page'>
      <div class='cell-huge'>
        <img src="https://a.id-photo-verify.com/ali_h5_a1/cdn/baidu_pic/baidu_specs_pic_six/usual.png"
             mode="aspectFit"
             id='fake-icon' />
        <img v-if="platformInfo.platform!=='wechat'" src="../assets/to_tutorial.png"
             mode="aspectFit"
             id='to-tutorial'
             @click="toTutorial" />
        <div class="spec-name">{{name}}</div>
      </div>
      <div class='cell-strange'
           v-if='ele'>
        <div class='judge-container'
             v-if='ele'>
          <img src="../assets/yes.png"
               mode="aspectFit"
               class='judge-icon' /><span>支持保存电子照</span>
        </div>
        <div class='judge-container'
             v-else>
          <img src="../assets/no.png"
               mode="aspectFit"
               class='judge-icon' /><span>不支持保存电子照</span>
        </div>
        <div class='judge-container'
             v-if='print'>
          <img src="../assets/yes.png"
               mode="aspectFit"
               class='judge-icon' /><span>支持打印纸质照</span>
        </div>
        <div class='judge-container'
             v-else>
          <img src="../assets/no.png"
               mode="aspectFit"
               class='judge-icon' /><span>不支持打印纸质照</span>
        </div>
      </div>
      <div class="cell">
        <div class="cell-title">冲印尺寸
        </div>
        <div class="cell-content">{{pagesize}}
        </div>
      </div>
      <div class="cell">
        <div class="cell-title">像素尺寸
        </div>
        <div class="cell-content"> {{px}}
        </div>
      </div>
      <div class="cell">
        <div class="cell-title">分辨率
        </div>
        <div class="cell-content">{{ppi}}
        </div>
      </div>
      <div class="cell">
        <div class="cell-title">文件大小
        </div>
        <div class="cell-content">{{weight}}
        </div>
      </div>
      <div class="cell">
        <div class="cell-title">颜色
        </div>
        <div class="circle-container">
          <div v-for="item in bgColor"
               :key="item.color_name"
               class="circle"
               :style="{background:'linear-gradient(#'+item.s_color+',#'+item.e_color+')',background:'-webkit-linear-gradient(#'+item.s_color+',#'+item.e_color+')',border:item.s_color==='ffffff' && item.e_color === 'ffffff'?'2px solid hsla(0, 0%, 73%, 0.3)':item.s_color!==item.e_color?'2px solid #'+item.e_color:'2px solid hsla(0, 0%, 100%, 0.3)'}"></div>
        </div>
      </div>
      <div class="cell cell-down">
        <div class="cell-title">其他
        </div>
        <div class="cell-content">无要求
        </div>
      </div>

    </div>
    <div class='button-container flexbox'>
      <img @click="takephoto" :src="require('@/assets/skins/'+platformInfo.skin+'/btn_left@3x.png')" class="leftBtn" />
	    <img @click="takecamera" :src="require('@/assets/skins/'+platformInfo.skin+'/btn_right@3x.png')" class="rightBtn" />
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState, mapActions } from "vuex";
import notify from "@/components/notify";
import { config } from "@/config/config";
import { toBase64 } from "@/utils/utils";
import { choosePhoto } from "@/utils/alipay";

export default {
  data () {
    return {
      isMakingPhoto: false,
      name: '',
      spec_id: '',
      px: '',
      pagesize: '',
      ppi: '',
      weight: '',
      bgColor: '',
      ele: '',
      print: ''
    };
  },
  computed: {
    ...mapState(["specInfo", "openId", "platformInfo", "actiBol", "processedPhoto"])
  },
  activated () {
    if(!this.actiBol){
      return;
    }
    let query = this.$route.query;
    if (query.specId) {
      let { specId, specName } = query;
      let specInfo = {
        specId,
        specName
      }
      this.RECORD_SPECINFO(specInfo);
    }
    this.processedPhoto.specId = this.specInfo.specId;
    this.processedPhoto.specName = this.specInfo.specName;
    this.RECORD_PROCESSED_PHOTO(this.processedPhoto);
    this.specDetail({specid:this.specInfo.specId}).then(res=>{
      this.getSpecInfo(res[0]);//显示详情内容
      this.canIPrint(res[1]);//显示是否可以冲印
      this.autolinkTutorial();
      this.testnospecid();
    })
  },
  methods: {
    ...mapMutations([
      "RECORD_ORDERINFO",
      "RECORD_PROCESSED_PHOTO",
      "RECORD_SELECTED_BG",
      "RECORD_SPECINFO",
      "RECORD_PLATFORMINFO_LOCAL"
    ]),
    ...mapActions(["specDetail"]),
    testnospecid() {
      let {specId:spec_id} = this.platformInfo;
      if (spec_id){
        //有规格id不走这一步
        return;
      }
      let platformInfo = {
          ...this.platformInfo,
          ...this.specInfo
        }
      this.RECORD_PLATFORMINFO_LOCAL(platformInfo)
    },
    autolinkTutorial() {
      if(this.platformInfo.judge&&this.platformInfo.judge!=="false"){
        this.toTutorial();
        this.platformInfo.judge = false;
        this.RECORD_PLATFORMINFO_LOCAL(this.platformInfo)
      }
    },
    getSpecInfo (res) {
        let d = res.result;
        console.log(d);
        let pagesize
        if (d.height_mm && d.width_mm) {
          pagesize = d.width_mm + ' × ' + d.height_mm + ' mm'
        }
        let weight
        if (d.file_size_max && d.file_size_min) {
          weight = ((d.file_size_min) / 1024) + '~' + ((d.file_size_max) / 1024) + 'KB'
        } else if (d.file_size_max) {
          weight = '不大于' + ((d.file_size_max) / 1024) + 'KB'
        } else if (d.file_size_min) {
          weight = '不小于' + ((d.file_size_min) / 1024) + 'KB'
        } else {
          weight = "无要求"
        }
        let bg_arr = JSON.parse(d.background_color); // 返回的背景色数组
        console.log(bg_arr);
        let bg_arr_list = [] // 返回的背景色变化后的值 
        for (let i = 0; i < bg_arr.length; i++) {
          let bgobj = bg_arr[i];
          let start_color = bgobj.start_color;
          let enc_color = bgobj.enc_color;
          let s_color = start_color.toString(16).padStart(6,0);
          let e_color = enc_color.toString(16).padStart(6,0);
          let color_name = bgobj.color_name;
          // bg_color.g = parseInt(bg_arr[i].start_color/256)%256;
          // bg_color.b=bg_arr[i].start_color%256;
          let bg_color = {
            start_color,
            enc_color,
            s_color,
            e_color,
            color_name
          }
          bg_arr_list.push(bg_color);
        }
        this.processedPhoto.backcolor = bg_arr_list;
        let ppi = d.ppi ? d.ppi : '无要求';
        this.name = d.name;
        this.spec_id = d.spec_id;
        this.px = d.width_px + ' × ' + d.height_px + ' px';
        this.pagesize = pagesize;
        this.ppi = ppi;
        this.weight = weight;
        this.bgColor = bg_arr_list;
	},
	takephoto() {
    let {platform,openid} = this.platformInfo;
    let { specId:spec_id } = this.processedPhoto;
    if(platform === 'baidu'){
      this.processedPhoto.picinfo = {};
      this.RECORD_PROCESSED_PHOTO(this.processedPhoto);
    }
		this.sdk.takephoto(platform,spec_id,openid).then(res=>{
      this.processedPhoto.picinfo = res.data;
      this.processedPhoto.picinfo.algo_fileuuid_beauty = res.data.algo_fileuuid;
      this.processedPhoto.picinfo.wm_url_beauty = res.data.wm_url;
      this.processedPhoto.picinfo.type=spec_id===619?'marriage':'ordinary'
      this.RECORD_PROCESSED_PHOTO(this.processedPhoto);
      let name = spec_id===619?'weddingEdit':'preview'
      this.$router.push({ name });
    })
	},
	takecamera() {
    let {platform,openid} = this.platformInfo;
    let { specId:spec_id } = this.processedPhoto;
    this.processedPhoto.picinfo = {};
    this.RECORD_PROCESSED_PHOTO(this.processedPhoto);
		this.sdk.takecamera(platform,spec_id,openid).then(res=>{
      if(res.data){
        this.processedPhoto.picinfo = res.data;
        this.processedPhoto.picinfo.type=spec_id===619?'marriage':'ordinary'
        this.RECORD_PROCESSED_PHOTO(this.processedPhoto);
        this.$router.push({ name: "weddingEdit" });
      }
    })
	},
    canIPrint (res) {
      let {ele,print}=res;
      this.ele = ele;
      this.print = print;
      this.processedPhoto.print = print;
    },
    toTutorial () {
      this.$router.push({
        name: "tutorial"
      });
    },
    convertImageToBase64 (e) {
      let file = e.target.files[0];
      toBase64(file, res => {
        this.makePhoto(
          res.base64_remove_head,
          this.platformInfo.specId,
          this.openId
        );
      });
    },
    clickInput () {
      this.$refs.imageLoader.click();
    },
  },

}
</script>

<style scoped>
.flexbox {
	display: flex;
	justify-content: center;
	align-items: center;
}
.leftBtn, .rightBtn {
	width: 1.75rem;
	height: 0.45rem;
	flex-shrink: 0;
}
.leftBtn {
	margin-right: 0.05rem;
}
.info-page {
  padding: 0.1rem;
}

.cell {
  height: 0.5rem;
  background-color: white;
  display: flex;
}

.cell-content {
  float: right;
  line-height: 0.5rem;
}

.cell-huge {
  width: 3.55rem;
  height: 1.85rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fff;
  position: relative;
}

#to-tutorial {
  width: 0.36rem;
  height: 0.95rem;
  position: absolute;
  right: 0;
  top: 0.23rem;
}

.spec-name {
  font-weight: bold;
  font-size: 0.17rem;
  color: #333333;
  text-align: center;
}

#fake-icon {
  width: 0.995rem;
  height: 1.05rem;
  margin-top: 0.25rem;
  margin-bottom: 0.1rem;
}

.cell-strange {
  width: 3.55rem;
  height: 0.35rem;
  background-color: rgba(244, 244, 255, 1);
}

.circle {
  width: 0.13rem;
  height: 0.13rem;
  border-radius: 50%;
  box-sizing: content-box;
  display: inline-block;
  margin: 0.145rem 0.06rem;
}

.circle-container {
  float: right;
}

.button-icon {
  width: 0.225rem;
  height: 0.225rem;
  margin-left: 0.35rem;
  margin-right: 0.03rem;
}

#button {
  width: 3.55rem;
  height: 0.45rem;
  background: rgba(68, 128, 231, 1);
  box-shadow: 0px 5px 10px 0px rgba(68, 128, 231, 0.25);
  border-radius: 0.225rem;
  line-height: 0.45rem;
  color: white;
  font-size: 0.16rem;
  display: flex;
  align-items: center;
  margin-left: 0.1rem;
  margin-top: 0.08rem;
}
#make-icon {
  width: 0.19rem;
  height: 0.16rem;
  margin-left: 1.2rem;
  margin-right: 0.13rem;
}

.judge-icon {
  width: 0.15rem;
  height: 0.15rem;
  margin-right: 0.05rem;
  margin-left: 0.2rem;
}
.judge-container {
  width: 50%;
  height: 0.35rem;
  display: inline-flex;
  align-items: center;
  text-align: center;
  font-size: 0.14rem;
  color:#666666;
}
</style>
